export default __webpack_public_path__ + "media/android.52d50101.svg";